/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PoolCommissionChangeLogResponseItem } from './pool-commission-change-log-response-item';


export interface PoolCommissionChangeLogResponseItemPagedList { 
    totalCount?: number;
    items?: Array<PoolCommissionChangeLogResponseItem> | null;
}

